import React, { useEffect, useState } from "react";
import { WifiOff, RefreshCw, CloudUpload } from "lucide-react";
import { toast } from "sonner";
import { getQueue, flushQueue } from "@/lib/offline";

export const OfflineBanner = () => {
  const [online, setOnline] = useState(navigator.onLine);
  const [pending, setPending] = useState(getQueue().length);
  const [syncing, setSyncing] = useState(false);

  const sync = async () => {
    if (getQueue().length === 0) return;
    setSyncing(true);
    const { done, failed } = await flushQueue();
    setSyncing(false);
    setPending(getQueue().length);
    if (done > 0) toast.success(`Synchronisation terminée ✓ ${done} action(s) hors-ligne envoyée(s) au serveur.`);
    if (failed > 0) toast.error(`${failed} action(s) hors-ligne rejetée(s) par le serveur.`);
  };

  useEffect(() => {
    const goOnline = () => { setOnline(true); toast.info("Connexion rétablie — synchronisation en cours..."); sync(); };
    const goOffline = () => { setOnline(false); toast.warning("Vous êtes hors ligne. Vous pouvez continuer à travailler, vos actions seront synchronisées.", { duration: 6000 }); };
    const onQueue = (e) => setPending(e.detail?.count ?? getQueue().length);
    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    window.addEventListener("mazid-queue-changed", onQueue);
    if (navigator.onLine) sync(); // au démarrage : rejouer ce qui reste
    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
      window.removeEventListener("mazid-queue-changed", onQueue);
    };
  }, []);

  if (online && pending === 0) return null;
  return (
    <div className={`fixed bottom-0 inset-x-0 z-[9998] px-4 py-2 text-sm font-semibold flex items-center justify-center gap-2 ${online ? "bg-[#1E3A8A] text-white" : "bg-amber-500 text-amber-950"}`}
      data-testid="offline-banner">
      {online ? (
        <>
          <CloudUpload className="h-4 w-4" />
          {pending} action(s) en attente de synchronisation
          <button onClick={sync} disabled={syncing} className="underline flex items-center gap-1 ml-2" data-testid="sync-now-btn">
            <RefreshCw className={`h-3.5 w-3.5 ${syncing ? "animate-spin" : ""}`} />Synchroniser maintenant
          </button>
        </>
      ) : (
        <>
          <WifiOff className="h-4 w-4" />
          Mode hors ligne — vos données affichées peuvent dater et vos actions ({pending}) seront synchronisées au retour du réseau
        </>
      )}
    </div>
  );
};
